import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { CuttingCustomGrooveSchema } from 'cloud-shared-lib';
import { CuttingPanelBaseSlot } from '../../models/cutting/cutting-panel-base-slot.model';

import { CuttingPanelSlot } from 'cloud-shared-lib';
import { Observable } from 'rxjs';
import { CustomSlotDetailDialogFormData } from '../slot-select/custom-slot-detail-dialog/custom-slot-detail-dialog.component';

export interface SlotsDialogData<Schema = CuttingCustomGrooveSchema, Slot = CuttingPanelSlot> {
  slots: CuttingPanelBaseSlot[];
  postCustomSlotsData?: (slot: Slot, schemaId: number) => Observable<number>;
  deleteCustomSlot?: (id: number) => Observable<void>;
  fullPanelThickness?: number;
  customSlotSchemas?: Schema[];
  mapSchemaToSlot?: (formData: CustomSlotDetailDialogFormData<Schema>) => Slot;
}

@Component({
  templateUrl: './slots-dialog.component.html',
  styleUrls: ['./slots-dialog.component.scss'],
})
export class SlotsDialogComponent {
  @HostBinding('class.slots-dialog-component')
  componentsClass = true;
  selected: CuttingPanelBaseSlot[];

  constructor(
    public dialogRef: MatLegacyDialogRef<SlotsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SlotsDialogData
  ) {}

  selectionChanged(items: CuttingPanelBaseSlot[]) {
    this.selected = items;
  }
}
